import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { JoiApp } from 'globals/store/app.data';
import { loadProgramTexts } from 'globals/store/programs.data';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { ExhibitorGalleryComponent } from 'src/app/modules/exhibitors/exhibitor.gallery.component';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-app-exhibitors',
    template: `
<exhibitor-gallery *ngIf="!!app?.eventData"
  [joiEvent]="app.eventData.eventInfo"
  [isPreview]="false"
  [entityName]="tabNames['exhibitorsTab']"
  (scrollUp)="scrollUp()"
></exhibitor-gallery>
`,
    styleUrls: ['./mobile-entities.scss'],
    standalone: true,
    imports: [ExhibitorGalleryComponent, CommonModule]
})
export class MobileAppExhibitorsComponent extends MobileAppWrapper<MobileAppExhibitorsComponent> {
  app: JoiApp
  programTexts = {}
  tabNames:{ [tId: string]: string } = getDefaultProgramTabNames() 

  constructor() {
    super()
    this.subCallback(this.store.select(mobileAppFeature.selectApp), app => {
      this.app = app
      if (!app) return
      const { tabNames, timeline, excludedFieldIds, eventInfo } = app.eventData
      if (tabNames) this.tabNames = tabNames
      this.programTexts = loadProgramTexts(timeline, excludedFieldIds, eventInfo.venues)
    })
  }

}

